import { ReactElement, memo } from 'react';

export interface Props {
  readonly anchorId: string;
}

function AnchorComponent({ anchorId }: Props): ReactElement {
  return <span id={anchorId} />;
}

export default memo(AnchorComponent);
